import { Typography } from '@mui/material';

const styles = {
	warningText: {
		color: '#d32f2f',
		marginTop: '0.25rem',
		width: '100%',
		textAlign: 'left'
	}
};

const SectionMismatchWarning = ({ detectedSectionName }) => (
	<Typography variant="caption" style={styles.warningText}>
		⚠️ Note: Selected section differs from detected live section ({detectedSectionName}). Please verify
		before proceeding.
	</Typography>
);

export default SectionMismatchWarning;
